module.exports = __webpack_public_path__ + "img/information-circle.611e8a3e.svg";